import React from "react"
import {
	Grid,
	Typography,
	Card,
	Box
} from "@material-ui/core"

import { themeColors } from "letalkui"

import { MeetingAnalysis } from "@/services/MeetingAnalyzerService"

import useMeetingAnalyzerStyles from "@/pages/Admin/MeetingAnalyzer/Detail/styles"
import useStyles from "@/pages/Admin/MeetingAnalyzer/Detail/TalkTimeCard/styles"

type TalkTimeCardProps = {
	analysis: MeetingAnalysis
}

const TalkTimeCard: React.FC<TalkTimeCardProps> = (props) => {
	const { analysis } = props

	const meetingAnalyzerClasses = useMeetingAnalyzerStyles()
	const classes = useStyles()

	if (!analysis.output) {
		return null
	}

	const closerPercentage = analysis.output.speechSplit.closer
	const leadPercentage = analysis.output.speechSplit.client

	return (
		<Card className={meetingAnalyzerClasses.card}>
			<Grid container direction="column" spacing={2}>
				<Grid item>
					<Typography className={meetingAnalyzerClasses.cardTitle}>
						% de tempo de fala
					</Typography>
				</Grid>
				<Grid item>
					<Box className={classes.talkTimeBar}>
						<Box className={classes.talkTimeCloserSegment} style={{ flexBasis: `${closerPercentage}%` }}>
							<Typography className={classes.talkTimeCloserLabel} style={{ color: themeColors.colors.base.white }}>
								{closerPercentage}%
							</Typography>
						</Box>
						<Box className={classes.talkTimeLeadSegment} style={{ flexBasis: `${leadPercentage}%` }}>
							<Typography className={classes.talkTimeLeadLabel} style={{ color: themeColors.colors.system.gray[900] }}>
								{leadPercentage}%
							</Typography>
						</Box>
					</Box>
				</Grid>
				<Grid item>
					<Grid container spacing={3}>
						<Grid item>
							<Grid container alignItems="center" spacing={1}>
								<Grid item>
									<Box className={classes.talkTimeDot} style={{ backgroundColor: themeColors.colors.system.purple[600] }} />
								</Grid>
								<Grid item>
									<Typography className={meetingAnalyzerClasses.metaLabel}>
										Closer
									</Typography>
								</Grid>
							</Grid>
						</Grid>
						<Grid item>
							<Grid container alignItems="center" spacing={1}>
								<Grid item>
									<Box className={classes.talkTimeDot} style={{ backgroundColor: themeColors.colors.system.beige[400] }} />
								</Grid>
								<Grid item>
									<Typography className={meetingAnalyzerClasses.metaLabel}>
										Lead
									</Typography>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Card>
	)
}

export default TalkTimeCard
